// extracted by mini-css-extract-plugin
export default {"metricsContainer":"dashBoard_metricsContainer__HPgzl","metricCard":"dashBoard_metricCard__M1wCy","title":"dashBoard_title__WJRAF","value":"dashBoard_value__QDYvk"};